<template>
    <div v-if="!hide" class="form-network form-network-linkedin" >
        <details open>
            <summary>Sondage <i class="fa-solid fa-caret-down"></i></summary>
            <div class="content-detail">
                <div class="type-switch">
                    Ajouter un sondage à la publication
                    <ComponentSwitch :value="formDataLinkedin.survey.active" :onChange="(v)=>{formDataLinkedin.survey.active = v, this.$emit('setFormDataNetwork', 'linkedin', this.formDataLinkedin)}" :id="'switch-settings-advanced-linkedin-1'"></ComponentSwitch>
                </div>

                <div class="form-sondage" v-if="formDataLinkedin.survey.active" >
                    <SelectComponent :changeValueSelect="changeDurationSurvey" :data="{oneDay:'Durée: 1 jour',threeDay:'Durée: 3 jours',oneWeek:'Durée: 1 semaine',twoWeek:'Durée: 2 semaines'}" :valueSelect="formDataLinkedin.survey.duration" :positionAuto="false" :positionX="'left'"></SelectComponent>
                    <div class="type-input">
                        <i class="fa-regular fa-circle-question"></i>
                        <input placeholder="Question du sondage" v-model="formDataLinkedin.survey.question" maxlength="140"/>>
                    </div>

                    <div class="list-question">
                        <div class="type-input">
                            <input placeholder="Choix 1" v-model="formDataLinkedin.survey.options[0]" maxlength="30"/>
                        </div>
                        <div class="type-input">
                            <input placeholder="Choix 2" v-model="formDataLinkedin.survey.options[1]" maxlength="30"/>
                        </div>
                        <div class="type-input" v-if="formDataLinkedin.survey.options.length >= 3">
                            <input placeholder="Choix 3" v-model="formDataLinkedin.survey.options[2]" maxlength="30"/>
                            <i class="fa-regular fa-square-minus" @click="()=>removeOptionSurvey(2)"></i>
                        </div>

                        <div class="type-input" v-if="formDataLinkedin.survey.options.length == 4">
                            <input placeholder="Choix 4" v-model="formDataLinkedin.survey.options[3]" maxlength="30"/>
                            <i class="fa-regular fa-square-minus" @click="()=>removeOptionSurvey(3)"></i>
                        </div>

                        <div class="btn-add" v-if="formDataLinkedin.survey.options.length < 4" @click="addOptionSurvey">
                            <p>Ajouter une option</p>
                            <i class="fa-solid fa-plus"></i>
                        </div>


                      
                      
                    </div>          
                </div>
                
            </div>      
        </details>
        <details v-if="formDataLinkedin.typeMedia =='pdf'" open>
            <summary>Document Pdf <i class="fa-solid fa-caret-down"></i></summary>
            <div class="content-detail">
                <div class="type-input">
                    <i class="fa-solid fa-pen-to-square"></i>
                    <input placeholder="Titre par default" v-model="formDataLinkedin.pdf.title">
                </div>
            </div>      
        </details>
 
        <details v-if="!formDataLinkedin.survey.active && formData.urlsTextContentHistory.size" open>
            <summary>Aperçu du lien <i class="fa-solid fa-caret-down"></i></summary>
            <div class="content-detail form-link">
                <div class="list-thubmmail">
    
                    <div class="thubmmail" v-for="(url) in this.formData.urlsTextContentHistory" @click="()=>selectUrl(url)" :key="url">
                        <Checkbox :id="url" :prefixId="'thubmmail-'" 
                            :isChecked="(formDataLinkedin.snippet.link == url)" 
                            :isDisable="(formDataLinkedin.snippet.link == url)"
                            :add="selectUrl" :remove="()=>{}">
                        </Checkbox>
                        <SnippetNetwork 
                            :link="url"
                            :imageUrlDefault="!inputModel.switchCustomSnippet || inputModel.titleSnippet || inputModel.descriptionSnippet ? undefined : inputModel.urlImageSnippet" 
                            :titleDefault="inputModel.switchCustomSnippet ? inputModel.titleSnippet : undefined" 
                            :descriptionDefault="inputModel.switchCustomSnippet ? inputModel.descriptionSnippet : undefined">
                        </SnippetNetwork>
                    </div>
                </div>
    
                <div class="type-switch"  v-if="formData.urlsTextContentHistory.length">
                    Apporter des modifications à l'aperçu du lien
                    <ComponentSwitch :value="inputModel.switchCustomSnippet" :onChange="(v) => switchCustomSnippetChange(v)" :id="'switch-settings-advanced-linkedin-2'"></ComponentSwitch>
                </div>
            
                <template v-if="inputModel.switchCustomSnippet && (formData.urlsTextContentHistory.length)">
                    <div class="type-btn-add">
                        <i class="fa-solid fa-image" @click="()=> formDataLinkedin.snippet.imageUrl = '' "></i>
                        Ajouter une image
                        <i class="fa-solid fa-plus" @click="()=> formDataLinkedin.snippet.imageUrl ='https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR4Xuh673slO7MDTuB8cYoOSpnbSUc7OyKwrA&s'"></i>
                    </div>
                    <div class="type-input">
                        <i class="fa-solid fa-pen-to-square"></i>
                        <input placeholder="Titre par default" v-model="formDataLinkedin.snippet.title">
                        <i class="fa-regular fa-square-minus" v-if="formDataLinkedin.snippet.title" @click="()=> formDataLinkedin.snippet.title =''"></i>
                    </div>
                </template>
            </div>
            
        </details>
   </div>
</template>

<script>
   import { EventBus } from '@/event-bus';
   import store from './../../../../store/index.js';
   import ComponentSwitch from '../../utils/switch.vue'
   import SelectComponent from '../../utils/select.vue'
   import SnippetNetwork from './../SnippetNetwork.vue'
   import minxinBot from '../../../mixins/Bots.vue'
   import minxinPost from '../../../mixins/Posts.vue'
   import Checkbox from '../../utils/checkbox.vue'
   export default {

       components: {
           ComponentSwitch,
           SelectComponent,
           SnippetNetwork,
           Checkbox
       },
       mixins: [minxinBot,minxinPost],

       props: {
           hide : {
               type: Boolean,
               default: false
           },
           formData: {
               type: Object,
               default: () => ({})
           },

           formDataLinkedin: {
               type: Object,
               default: () => ({})
           },

           files:Object
       },

       data() {
           return {
                inputModel:{
                    switchCustomSnippet: false,
                    urlImageSnippet: "",
                    titleSnippet: "",
                    descriptionSnippet: "",
                },

                lastModeSelected : undefined
           }
       },

       
       mounted() {
            if (this.formData.formDataNetwork.linkedin) this.formDataLinkedin = this.formData.formDataNetwork.linkedin
          
       },

       methods: {
            addMode(mode) {
                this.lastModeSelected = mode
                EventBus.$emit("postCreatorAddMode", mode);
            },

            detectTypeContent() {
                if(this.formData.files.length) { 
                    try {
                        this.formDataLinkedin.typeMedia = this.files[this.formData.files.find(f => ['video','image','pdf'].includes(this.files[f.id].info.type2)).id].info.type2
                        this.$emit('setFormDataNetwork', 'linkedin', this.formDataLinkedin)
                    } catch (error) {
                        console.error("Impossible de détecter le type des médias. formLinkedin.vue/detectTypeContent")
                    }
                }
            },

            addOptionSurvey() {
                this.formDataLinkedin.survey.options = [...this.formDataLinkedin.survey.options, ''].slice(0,4)
                this.$emit('setFormDataNetwork', 'linkedin', this.formDataLinkedin)
            },

            removeOptionSurvey(index) {
                this.formDataLinkedin.survey.options = this.formDataLinkedin.survey.options.filter((o,i) => i !== index)
                this.$emit('setFormDataNetwork', 'linkedin', this.formDataLinkedin)
            },

            changeDurationSurvey(duration) {
                this.formDataLinkedin.survey.duration = duration
                this.$emit('setFormDataNetwork', 'linkedin', this.formDataLinkedin)
            },

            switchCustomSnippetChange(v) {
                this.inputModel.switchCustomSnippet = v
                if (!v) {
                    this.formDataLinkedin.snippet.title = ''
                    this.formDataLinkedin.snippet.imageUrl = ''
                    this.$emit('setFormDataNetwork', 'linkedin', this.formDataLinkedin)
                }
            },
           
            selectUrl(url) {
  
                if (!this.formDataLinkedin.snippet) this.formDataLinkedin.snippet = {}
                this.formDataLinkedin.snippet.link = this.formDataLinkedin.snippet.link == url ? '' : url
                this.$emit('setFormDataNetwork', 'linkedin', this.formDataLinkedin)
            },

            verifUrlSelected(urlsTextContentHistory = []) {
                urlsTextContentHistory = this.formData.urlsTextContentHistory

                if (urlsTextContentHistory.size) {
                    let linkSelect = this.formDataLinkedin && this.formDataLinkedin.snippet && this.formDataLinkedin.snippet.link ? this.formDataLinkedin.snippet.link : null
                    if ((linkSelect && !urlsTextContentHistory.has(linkSelect)) || !linkSelect) {
                        this.selectUrl(urlsTextContentHistory.values().next().value)
                    }
                }else{
                    this.selectUrl('')
                }
             
            },
       },

       computed: {
           allPages() {
               return this.$store.getters['selectPage/selectPageAllPages'];
           },
           pagesSelected() {
               return this.$store.getters['selectPage/selectPagePageSelected'];
           },
       },

       watch: {
            ['formData.formDataNetwork.linkedin']() {
                if (this.formData.formDataNetwork.linkedin) this.formDataLinkedin = this.formData.formDataNetwork.linkedin
            },
            'formData.urlsTextContentHistory'(newValue) {
                this.verifUrlSelected()
            },
            'formData.files'(newValue) {
                this.detectTypeContent()
            },

            ['formDataLinkedin.survey.options']() {
                this.$emit('setFormDataNetwork', 'linkedin', this.formDataLinkedin)
            },
            ['formDataLinkedin.survey.question']() {
                this.$emit('setFormDataNetwork', 'linkedin', this.formDataLinkedin)
            },
            ['formDataLinkedin.pdf.title']() {
                this.$emit('setFormDataNetwork', 'linkedin', this.formDataLinkedin)
            },
            ['formDataLinkedin.snippet.title']() {
                this.$emit('setFormDataNetwork', 'linkedin', this.formDataLinkedin)
            },

           
       },


       beforeDestroy () {
         
       }
       
   }
</script>